import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      {...props}
      width={22}
      height={12}
      viewBox="0 0 22 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <Path
        d="M.826 4.791a1.01 1.01 0 01.17-.012h17.951l-.212-.095a1.969 1.969 0 01-.555-.383l-2.72-2.643A.969.969 0 0115.316.39a1.003 1.003 0 011.475-.124l4.92 4.78a.937.937 0 010 1.352l-4.92 4.78a1.004 1.004 0 01-1.475-.095.969.969 0 01.142-1.267l2.716-2.648c.144-.14.31-.258.492-.349l.295-.129H1.05a1.012 1.012 0 01-1.038-.803.96.96 0 01.813-1.097z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
